import script from "./accordion.vue?vue&type=script&setup=true&lang=js"
export * from "./accordion.vue?vue&type=script&setup=true&lang=js"

import "./accordion.vue?vue&type=style&index=0&id=7dc4e144&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dc4e144"]])

export default __exports__